// import React from "react";
// import "./DefaultLayout.scss";
// import logo from "../../app/assets/img/aadi-login-logo.png";
// import sideImage from '../../app/assets/img/landing-page-side-image.png'
// import { useMediaQuery } from "react-responsive";


// const DefaultLayout = ({ newChatStart }) => {

//   let isTab = useMediaQuery({ query: "(max-width: 768px)" });

//   return (
//     <>
//       <div className="DefaultPage">
//         <img className="side-image" src={sideImage} alt="sideImage" />
//         <div className="default-container">
//           <div className="logo-section">
//             <p>Welcome to </p>
//             <img src={logo} alt="Aadi" />
//           </div>

//           <div className="intro-section">
//             Your Decision Intelligence Co-Pilot for Finance. Navigate complex
//             financial landscapes with ease and precision.
//           </div>

//           <div className="description-text">
//             Discover the power and intelligence of Finance Co-Pilot in a highly
//             distributed enterprise ecosystem. Break down information silos and
//             perform root-cause analysis, flux reporting, variance/bridge
//             analysis, anomaly detection and more. AaDI is powered by agentic
//             workflows, knowledge graphs, Q&A and conversation capabilities,
//             ensuring seamless cross-functional information exchange and enhanced
//             decision-making.
//           </div>

//           <button
//             onClick={newChatStart}
//             className="ask-me-btn"
//             style={{
//               textTransform: "uppercase",
//               borderRadius: "6px",
//               position:"relative"
//             }}
//           >
//             Ask Me
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DefaultLayout;


import React from "react";
import bgimage from "../../app/assets/img/aadi.gif";
import { useHistory } from "react-router-dom";
import logo from "../../app/assets/img/aadi-login-logo.png";

const DefaultPage = ({ newChatStart }) => {
  const history = useHistory();

  return (
    <div className="mx-auto p-8 pt-4">
      <div className="flex flex-col gap 2">
        <div>
          <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#bb1ccc] to-[#bb1ccc] mb-4  flex gap-2 text-center">
           <span> Welcome to</span> 
           <span><img width={60} src={logo} alt="Aadi" /></span>
          </div>

          <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Your Decision Intelligence Co-Pilot for Supply Chain. Navigate complex logistics networks with speed, visibility, and precisio.
          </h2>

          <p className="text-gray-600 mb-2 leading-relaxed max-w-8xl text-[14px]">
          Discover the power and intelligence of the Supply Chain Co-Pilot in a highly distributed enterprise ecosystem. Break down operational silos and perform root-cause analysis, demand–supply forecasting, inventory optimization, anomaly detection, and more. AaDI is powered by agentic workflows, knowledge graphs, Q&A, and conversational capabilities—ensuring seamless collaboration across procurement, manufacturing, and logistics for smarter, faster decision-making
          </p>

          <div className="max-w-4xl">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Why Aadi?
            </h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li className="text-[12px]">
                 <span className="text-[12px]">Custom Date Ranges</span > –
                Generate focused, in-depth supply chain summaries tailored to your operational goals.
              </li>
              <li className="text-[12px]">
                 <span className="text-[12px]">Instant Insights</span> –
                Access real-time intelligence across suppliers, logistics, and inventory performance without manual effort.
              </li>
              <li className="text-[12px]">
                 <span className="text-[12px]">Market Coverage</span> – Stay updated on supplier reliability, shipment trends, geopolitical risks, and regulatory changes impacting your supply chain.
              </li>
             
            </ul>
          </div>
        </div>

        <div style={{ minHeight: "20px" }}></div>

        <div
          style={{
            backgroundImage: `url(${bgimage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="bg-black rounded-2xl p-8 relative overflow-hidden h-[300px]"
        >
          <div style={{alignContent:"center",alignItems:"center"}} className="relative z-10 grid gap-4 h-[100%]">
            <h3 className="text-2xl font-bold bg-clip-text bg-gradient-to-r text-[#bb1ccc]">
              Ask Aadi
            </h3>
            <p className="text-white max-w-[60%]">
            Your decision intelligence platform for FWA analysis, turning complex data into clear, actionable insights. Quickly uncover key growth drivers and make faster, smarter decisions in a dynamic market.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={newChatStart}
                className="flex items-center space-x-2 px-6 py-2 border border-gray-600 rounded-lg text-white hover:bg-white/10 transition-colors bg-transparent"
              >
                <div className="w-4 h-4 border border-current rounded-full flex items-center justify-center">
                  <div className="w-2 h-2 bg-current rounded-full"></div>
                </div>
                <span>Start Chat</span>
              </button>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultPage;

